import { render, staticRenderFns } from "./housemaid-policy-form.vue?vue&type=template&id=4b08e7e3&scoped=true&"
import script from "./housemaid-policy-form.vue?vue&type=script&lang=js&"
export * from "./housemaid-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./housemaid-policy-form.vue?vue&type=style&index=0&id=4b08e7e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b08e7e3",
  null
  
)

export default component.exports